import styled from 'styled-components';

export const ProgressBar = styled.div<{ value: number; max: number }>`
    width: 100%;
    height: 0.8rem;
    background-color: ${({ theme }) => theme.colors.yellow[50]};
    border-radius: 2.4rem;
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: ${({ value, max }) => `${(value / max) * 100}%`};
        background-color: ${({ theme }) => theme.colors.yellow[500]};
        border-radius: 2.4rem;
        transition: width 200ms ease;
    }
`;
